import * as types from './actionTypes';

function url() {
  return 'api/RoomMap/';
}


export function receiveRoomMap(roomMap) {
  return {
    type: types.ROOMMAP_RECEIVE, 
    roomMap:   {
      mapTitle: (roomMap && roomMap.mapImage && roomMap.mapImage.title || ''),
      thumbnailUrl: (roomMap && roomMap.mapImage && roomMap.mapImage.thumbnailUrl || ''),
      largeUrl: (roomMap && roomMap.mapImage && roomMap.mapImage.originalUrl || ''),
      location: {
        x:  roomMap && roomMap.room && roomMap.room.location && roomMap.room.location.x || 0,
        y: roomMap && roomMap.room && roomMap.room.location && roomMap.room.location.y || 0
      }
  },};
}

export function roomMapIsLoading(bool) {
  return {
    type: types.ROOMMAP_ISLOADING, 
    isLoading: bool
  };
}

export function receiveRoomAPIError(bool, errorMessage) {
  return {
    type: types.ROOMMAP_APIERROR, 
    hasErrored: bool,
    errMsg: errorMessage};
}

export function fetchRoomMap(roomName) {
  return (dispatch, getState) => {
    
    const state = getState();
    let mrm_exchangeToken ='', mrm_ssoToken= '';

    if(state != null) {
       mrm_ssoToken = state.userRegTokens.ssoToken;
       mrm_exchangeToken = state.userRegTokens.exchangeToken;
    }
    
    dispatch(roomMapIsLoading(true));

    if(!mrm_exchangeToken) {
      console.log('No exchange token - skip calling room api...');
      return;
    }

      return fetch(url() +encodeURI(roomName), {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + mrm_ssoToken,
        "X-ExchangeToken": mrm_exchangeToken
      }
    })
    .then( (response) => {
        if (!response.ok) { throw response; }
        return response.json(); //we only get here if there is no error
    })
    .then( 
      (roomMap) => {
        dispatch(receiveRoomMap(roomMap));
        dispatch(roomMapIsLoading(false));
      }
     )
    .catch( (err) =>  {
        console.log("API Error:");
        console.dir(err);
        dispatch(receiveRoomAPIError(true, err.statusText));
      }
    );
  };
}


